import { Image, Typography } from "antd";
import { RootStateOrAny, connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import {
  getMemberAwvDetails,
  getHmoAwvMetrics,
  getMemberMpi,
  HmoAwvMetricsModel,
  updateMemberAwvStatus,
  MemberBatchUpdateModel,
  refreshMemberAwvStatus,
  RefreshMemberAwvStatusModel,
  downloadMemberPafs,
  MemberPafModel,
  HmoMemberAwvDetailsModel,
  MemberMpiSearchModel,
  downloadAwvStatusExcel,
  MemberExcelStatusModel,
  downloadAwvStatusPdf,
} from "store/app/hmo/actions";
import { uploadFilestoAuth } from 'store/authorization/files/actions';
import { getDistinct } from "store/app/providerKeyListWDates/actions";
import { downloadFileFromBlob } from "store/authorization/files/actions";

import HmoTable from "components/AWV/HMO";
import notifier from "utils/notifier";
import { ErrorResponse } from "utils/types";
import { getMimeType } from "utils/helpers";
import { Application } from "utils/enums";

import microphone from 'assets/images/microphone.png';
import styles from "./HMOPage.module.scss";

interface AWVHMOPageProps {
  isFetchingHmoMetrics: boolean;
  isFetchingAwv: boolean;
  isFetchingDistinct: boolean;
  selectedProviderKeyId: string;
  isUpdatingHmoMetrics: boolean;
  isRefreshingMemberAwvStatus: boolean;
  isDownloadingMemberPafs: boolean;
  isDownloadingMemberStatusExcel: boolean;
  getDistinct(userId: string): any;
  getMemberAwvDetails(payload: HmoMemberAwvDetailsModel): any;
  getHmoAwvMetrics(payload: HmoAwvMetricsModel): any;
  getMemberMpi(payload: MemberMpiSearchModel): any;
  updateMemberAwvStatus(payload: MemberBatchUpdateModel): any;
  refreshMemberAwvStatus(payload: RefreshMemberAwvStatusModel): any;
  downloadMemberPafs(payload: MemberPafModel): any;
  downloadAwvStatusExcel(payload: MemberExcelStatusModel): any;
  downloadAwvStatusPdf(payload: MemberExcelStatusModel): any;
  uploadFilestoAuth(options: Object): any,
  downloadFileFromBlob(companyId: string, application: string, filepath: string): any,
}

const AWVHMOPage = (props: AWVHMOPageProps) => {
  const { Title } = Typography;

  const downloadFileFromBlob = (filepath: string) => {
    props.downloadFileFromBlob('AllIPA', Application.ProviderPortal, filepath)
      .then((response: string) => {
        const mimeType = getMimeType(filepath);
        let blob = new Blob([response], { type: mimeType });
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL, "_blank", "");

      })
      .catch((err: ErrorResponse) => {
        notifier.error(err.response.data.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  return (
    <div className={styles["aco-page"]}>
      <div className={styles["header-title"]}>
        <Title level={4}>Annual Visit</Title>
      </div>
      <div>
        <div className={styles["awv-blurb"]}>
          <img src={microphone} className={styles["microphone-icon"]} /> This is your new annual visit chase list. Here's
          <a href="https://astranahealth.notion.site/Astrana-Portal-Annual-Visit-Page-67a124716ed143219d01ee5c197b0d24" target="_blank">{ } <span className={styles["how-it-works"]}>how it works</span></a>
          <a className={styles['provide-feedback']} href="mailto:providerportal@astranahealth.com?subject=Provider Portal Feedback">Provide Feedback</a>
        </div>
        <HmoTable
          getHmoAwvMetrics={props.getHmoAwvMetrics}
          getDistinct={props.getDistinct}
          getMemberAwvDetails={props.getMemberAwvDetails}
          isFetchingHmoMetrics={props.isFetchingHmoMetrics}
          isFetchingDistinct={props.isFetchingDistinct}
          isFetchingAwv={props.isFetchingAwv}
          selectedProviderKeyId={props.selectedProviderKeyId}
          updateMemberAwvStatus={props.updateMemberAwvStatus}
          isUpdatingHmoMetrics={props.isUpdatingHmoMetrics}
          refreshMemberAwvStatus={props.refreshMemberAwvStatus}
          isRefreshingMemberAwvStatus={props.isRefreshingMemberAwvStatus}
          downloadMemberPafs={props.downloadMemberPafs}
          downloadAwvStatusExcel={props.downloadAwvStatusExcel}
          downloadAwvStatusPdf={props.downloadAwvStatusPdf}
          isDownloadingMemberPafs={props.isDownloadingMemberPafs}
          isDownloadingMemberStatusExcel={props.isDownloadingMemberStatusExcel}
          getMemberMpi={props.getMemberMpi}
          uploadFilestoAuth={props.uploadFilestoAuth}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (store: RootStateOrAny) => ({
  isFetchingDistinct:
    store.rootReducer.appProviderKeyListWDates.isFetchingDistinct,
  isFetchingAwv: store.rootReducer.hmo.isFetchingAwv,
  selectedProviderKeyId: store.rootReducer.hmo.selectedProviderKeyId,
  isFetchingHmoMetrics: store.rootReducer.hmo.isFetchingHmoMetrics,
  isUpdatingHmoMetrics: store.rootReducer.hmo.isUpdatingHmoMetrics,
  isRefreshingMemberAwvStatus:
    store.rootReducer.hmo.isRefreshingMemberAwvStatus,
  isDownloadingMemberPafs: store.rootReducer.hmo.isDownloadingMemberPafs,
  isDownloadingMemberStatusExcel:
    store.rootReducer.hmo.isDownloadingMemberStatusExcel,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      getHmoAwvMetrics,
      getMemberMpi,
      getMemberAwvDetails,
      getDistinct,
      updateMemberAwvStatus,
      refreshMemberAwvStatus,
      downloadMemberPafs,
      downloadAwvStatusExcel,
      downloadAwvStatusPdf,
      uploadFilestoAuth,
      downloadFileFromBlob
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AWVHMOPage);
